import { pluginAudio } from './../../plugin-audio/viewer';
import { pluginActionButton, pluginLinkButton } from './../../plugin-button/viewer';
import { pluginCodeBlock } from './../../plugin-code-block/viewer';
import { pluginCollapsibleList } from './../../plugin-collapsible-list/viewer';
import { pluginDivider } from './../../plugin-divider/viewer';
import { pluginEmoji } from './../../plugin-emoji/viewer';
import { pluginGallery } from './../../plugin-gallery/viewer';
import { pluginGiphy } from './../../plugin-giphy/viewer';
import { pluginHashtag } from './../../plugin-hashtag/viewer';
import { pluginHtml } from './../../plugin-html/viewer';
import { pluginImage } from './../../plugin-image/viewer';
import { pluginIndent } from './../../plugin-indent/viewer';
import { pluginLineSpacing } from './../../plugin-line-spacing/viewer';
import { pluginLink } from './../../plugin-link/viewer';
import { pluginLinkPreview } from './../../plugin-link-preview/viewer';
import { pluginMentions } from './../../plugin-mentions/viewer';
import { pluginSpoiler } from './../../plugin-spoiler/viewer';
import { pluginTable } from './../../plugin-table/viewer';
import { pluginTextColor, pluginTextHighlight } from './../../plugin-text-color/viewer';
import { pluginVerticalEmbed } from './../../plugin-vertical-embed/viewer';
import { pluginVideo } from './../../plugin-video/viewer';

export const quickStartViewerPlugins = () => {
  return [
    pluginActionButton(),
    pluginAudio(),
    pluginCodeBlock(),
    pluginCollapsibleList(),
    pluginDivider(),
    pluginEmoji(),
    pluginGallery(),
    pluginGiphy(),
    pluginHashtag(),
    pluginHtml(),
    pluginImage(),
    pluginIndent(),
    pluginLineSpacing(),
    pluginLink(),
    pluginLinkButton(),
    pluginLinkPreview(),
    pluginMentions(),
    pluginSpoiler(),
    pluginTable(),
    pluginTextColor(),
    pluginTextHighlight(),
    pluginVerticalEmbed(),
    pluginVideo(),
  ];
};
